import React from "react"

export default function AcceleratorPartners(){
    return (
        <div className="flex flex-col mt-28 lg:mt-60 mb-0 w-full px-6">
            <h2 className="font-kulim text-2xl font-semibold mx-auto text-center mt-0 mb-14">
                Backed by innovators who build the future.
            </h2>
            <div className="flex flex-wrap justify-evenly">
                <img 
                    src={require('../../../assets/landingAssets/ac-logo.png')} 
                    className="w-40 h-12 lg:w-60 lg:h-20 mb-4 lg:my-auto lg:ml-auto"
                />
                <img 
                    src={require('../../../assets/landingAssets/ifh-logo.png')} 
                    className="w-32 h-16 lg:w-56 lg:h-28 mb-4 mx-3 md:mx-auto lg:my-auto"
                />
                <img 
                    src={require('../../../assets/landingAssets/ingenuity-logo.png')} 
                    className="w-32 h-9 lg:w-44 lg:h-14 mb-4 lg:my-auto lg:mr-auto"
                />
            </div>     
        </div>
    )
}